import TransitApi from './base'
import { createFormData } from '@/helpers/TransitHelper'

export default {
  // TODO: Add search, filters and sort params
  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/invoice/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Guarda montos y el switch de quién paga el impuesto.
  async updateAccounting(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/accounting', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Avisa si otro trámite ya tiene ese N° de factura Alegra. Solo consulta:
  // el número se guarda igual, porque una factura puede cubrir dos trámites.
  async checkAlegraNumber(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/invoice/alegra-number-check?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // ===== Facturación por servicios =====
  async getServiceConcepts() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/invoice/service-concepts')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async saveServiceConcept(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/service-concepts', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getServiceRates() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/invoice/service-rates')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async saveServiceRate(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/service-rates', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async deleteServiceRate({ id }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/invoice/service-rates/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getServiceItems({ ids }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/invoice/service-items/${ids}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async generateServiceItems(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/service-items/generate', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async saveServiceItem(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/service-items', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async deleteServiceItem({ id }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/invoice/service-items/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async uploadServiceDocs(params) {
    try {
      const Api = TransitApi.getSecureInstanceMultipart()
      const data = createFormData(params)
      const result = await Api.post('/invoice/service-items/documents', data)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // ===== Reembolsos =====
  async getReimbursementConcepts() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/invoice/reimbursement-concepts')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async saveReimbursementConcept(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/reimbursement-concepts', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getReimbursements({ ids }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/invoice/reimbursements/${ids}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async saveReimbursement(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/reimbursements', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async deleteReimbursement({ id }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/invoice/reimbursements/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async uploadReimbursementDocs(params) {
    try {
      const Api = TransitApi.getSecureInstanceMultipart()
      const data = createFormData(params)
      const result = await Api.post('/invoice/reimbursements/documents', data)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Tramos de la tarifa de corretaje aduanal.
  async getCustomsRates() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/invoice/customs-rates')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async saveCustomsRate(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/customs-rates', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async deleteCustomsRate({ id }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/invoice/customs-rates/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Recalcula la facturación por servicios aduanales desde la tabla de tarifas.
  async recalculateCustoms(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/accounting/recalculate', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Elimina un documento de la bitácora (y su archivo).
  async deleteDocument({ id }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/invoice/documents/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Bitácora de documentos del trámite. `ids` puede ser una factura o varias
  // separadas por coma, para ver la bitácora completa de un consolidado.
  async getDocuments({ ids, step }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const query = step ? `?step=${step}` : ''
      const result = await Api.get(`/invoice/documents/${ids}${query}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Actualiza Notaría y/o Comentario de procesamiento de un trámite.
  async updateProcessFields(id, params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/invoice/process-fields/${id}`, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getTransitList(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/invoice/list-transit?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Listado agrupado por consolidación, paginado a nivel de cuadrante.
  async getConsolidated(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/invoice/list-consolidated?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Consolidar: amarra 2+ facturas generando un fdcontrolNumber (CONS-...).
  async consolidate(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/consolidate', params)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Agregar facturas a un consolidado (padre) existente y recalcular totales.
  // params: { parentId, invoicesID: [...] }
  async addToConsolidated(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/consolidate/add', params)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Quitar facturas de un consolidado sin disolver el padre; recalcula totales.
  // params: { parentId, invoicesID: [...] }
  async removeFromConsolidated(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/consolidate/remove', params)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Des-consolidar: quita el amarre (limpia el fdcontrolNumber).
  async deconsolidate(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/deconsolidate', params)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Guardar (reemplazar) los motivos de pendiente de una factura.
  // params: { invoiceId, reasonIds: [...] }
  async setPendingReasons(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/invoice/pending-reasons', params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/invoice/details/${params.id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/invoice/details/${params.id}` : '/invoice/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/delete'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getProducts(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      let result = await Api.get(`/invoice/products?${queryString}`)
      return result.data
    } catch (error) {
      return null
    }
  },
}
